export const FETCH_ONE = 'OPEN.SURVEY.FETCH_ONE';
export const CLEAR_ONE = 'OPEN.SURVEY.CLEAR_ONE';
